import React from 'react'
import { default as CommonTooltip } from '../../../../../../../../common/components/Tooltip/Tooltip'
import './Tooltip.scss'

const Tooltip = ({ tooltipText, onClick, position }) => {
    const text = tooltipText ? <span className="tooltip-controls-icon" /> : null

    return <CommonTooltip text={text} tooltipText={tooltipText} onClick={onClick} position={position} />
}
export default Tooltip
